import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BillsService } from "../../../../injections/bills.service";

@Component({
    selector: 'header-bill-gyh',
    templateUrl: '../../templates/partials/header-bill.html'
})

export class HeaderGYHBillComponent implements OnInit {

    @Input() paidBill;
    @Input() data;
    @Output() openModalEmitter = new EventEmitter();
    @Output() openModalBillEmitter = new EventEmitter();
    @Output() openModalDownloadEmitter = new EventEmitter();
    public buttonDowloadD = false;
    constructor(private router: Router, private billsService: BillsService) { }

    public sendBill(){
        //console.log("Send");
    }

    public downloadBill(){
        
        //this.buttonDowloadD = true;
        this.openModalDownloadEmitter.next({action: "open", data: null});
        /*this.billsService.downloadBillGYH(this.data["cleanerId"].toString(), this.data["date_period"]).subscribe( result => {
            var fileURL = URL.createObjectURL(result);
            var link = document.createElement('a');
            link.href = fileURL;
            link.download = this.data["cleanerName"].replace(/ /g, "").replace(",","") +'_'+ this.data["date_period"] + '.pdf';
            link.click();
            this.buttonDowloadD = false;
        });*/        
    }

    public seeBill() {
        this.openModalBillEmitter.next({action: "open", data: this.data});
    }

    public showModalPayment(payment: number){
        this.openModalEmitter.next({action: "open", data: payment});
    }
    

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/headerGYH-bill.component.ts